'use strict'

class NewsDetailShare{
    constructor(){
        this.main = document.getElementById('news_detail_share');

        //this._url = App.baseUrl + App.sitemap.news_detail.slug + this.main.getAttribute('data-slug');
        this._url = this.main.getAttribute('data-hash');
        this._text = this.main.getAttribute('data-text');

        this._twitterBtn = this.main.querySelector('.twitter_btn');
        this._whatsappBtn = this.main.querySelector('.whatsapp_btn');
        this._facebookBtn = this.main.querySelector('.facebook_btn');
        this._linkedinBtn = this.main.querySelector('.linkedin_btn');

        if(this._twitterBtn){
            this._twitterBtn.addEventListener('click', this._onClickTwitterBtn.bind(this));
        }
        if(this._whatsappBtn){
            this._whatsappBtn.addEventListener('click', this._onClickWhatsappBtn.bind(this));
        }
        if(this._facebookBtn){
            this._facebookBtn.addEventListener('click', this._onClickFacebookBtn.bind(this));
        }
        if(this._linkedinBtn){
            this._linkedinBtn.addEventListener('click', this._onClickLinkedinBtn.bind(this));
        }
    }

    _onClickTwitterBtn(e){
        e.preventDefault();
        window.open('https://twitter.com/intent/tweet?text='+encodeURIComponent(this._text)+'&url='+this._url, 'twShareWindow', 'height=450, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    }

    _onClickWhatsappBtn(e){
        e.preventDefault();
        window.open('https://web.whatsapp.com/send?text='+encodeURIComponent(this._text)+'. '+this._url, 'twShareWindow', 'height=450, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    }

    _onClickFacebookBtn(e){
        e.preventDefault();    
        window.open('https://www.facebook.com/sharer/sharer.php?u='+this._url, 'fbShareWindow', 'height=600, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    }

    _onClickLinkedinBtn(e){
        e.preventDefault();
        window.open('https://www.linkedin.com/shareArticle?mini=true&url='+this._url+'&title='+encodeURIComponent(this._text), 'ldShareWindow', 'height=600, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    }

}

export default NewsDetailShare;